import {
	GET_TRANSFER_DESTINATIONS_SUCCESS,
	GET_TRANSFER_DESTINATIONS_REQUEST,
	GET_TRANSFER_PREFILL_SUCCESS,
} from '../../actions/api';

const transfersReducer = (state = {}, action) => {
	switch (action.type) {
		case GET_TRANSFER_DESTINATIONS_REQUEST:
			return {
				...state,
				destinations: null,
			};
		case GET_TRANSFER_DESTINATIONS_SUCCESS:
			return {
				...state,
				destinations: action.response.destinations,
			};
		case GET_TRANSFER_PREFILL_SUCCESS:
			return {
				...state,
				prefillTransfer: action.response.prefillTransfer,
			};

		default:
			return state;
	}
};

export default transfersReducer;
